import { render, staticRenderFns } from "./ChangeSortCriterion.vue?vue&type=template&id=7c3ba4c0"
import script from "./ChangeSortCriterion.vue?vue&type=script&setup=true&lang=js"
export * from "./ChangeSortCriterion.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports